var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.isLoading)?_c('div',[_vm._v(" Loading... ")]):_c('div',[_c('NavBar',{on:{"localeChange":_vm.loadLocaleMessages}}),_c('div',[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }